import { ImageUploadField } from "@/(admin)/modules/ui-builder/config/lib/ImageUploadField"
import { ComponentConfig } from "@measured/puck"
import { FooterProps, RenderConfig } from "./RenderConfig"

export const DansFooter: ComponentConfig<FooterProps> = {
  label: "Dans | Footer",
  fields: {
    logoImage: {
      label: "Logo URL",
      type: "custom",
      render: props => <ImageUploadField {...props} />,
    },
    servicesItems: {
      label: "Services Items",
      type: "array",
      arrayFields: {
        title: {
          label: "Title",
          type: "text",
        },
        url: {
          label: "URL",
          type: "text",
        },
      },
    },
    contactInfoItems: {
      label: "Contact Info Items",
      type: "array",
      arrayFields: {
        url: {
          label: "URL",
          type: "text",
        },
        contactInfo: {
          label: "Contact Info",
          type: "text",
        },
        isGmail: {
          label: "Contact Type",
          type: "select",
          options: [
            { label: "Gmail", value: "Gmail" },
            { label: "Phone", value: "Phone" },
            { label: "Address", value: "Address" },
          ],
        },
        iconUrl: {
          label: "Icon URL",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
      },
    },
    iconList: {
      label: "Icon",
      type: "array",
      arrayFields: {
        icon: {
          label: "Icon",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
        url: {
          label: "URL",
          type: "text",
        },
      },
    },

    className: {
      label: "Class Name",
      type: "text",
    },
  },
  ...RenderConfig,
}
